const ProgressBar = ({value}) => {
    return (
        <div class="w-full bg-neutral-200 dark:bg-neutral-400 rounded">
            <div
                class="bg-primary p-0.5 text-center text-xs font-medium leading-none text-white rounded"
                style={{width: Math.round(value) + "%"}}>
                {Math.round(value)  + "%"}
            </div>
        </div>
    )
}

export default ProgressBar